/* eslint-disable no-console */
import { axiosClient } from '../../api';

const state = {
  referrers: {},
  referralsAll: {},
  referrersPending: {},
  referralsPending: {},
  payoutTags: {},
  salesReps: {},
  customers: {},
  contacts: {},
  notifications: {},
  products: {},
  accessories: {},
  machineTypes: {},
  groupCategories: {},
  templates: {},
  timeSlots: [],
  timeSlot: null,
  series: [],
};

const getters = {};

// helpers
const updateState = (update, state, prop) => {
  state[prop] = {
    meta: state[prop]['meta'],
    data: state[prop]['data'].map(item => (item.id === update.id ? { ...item, ...update } : item)),
  };
};

const removeFromState = (id, state, prop) => {
  state[prop]['data'] = state[prop]['data'].filter(item => item.id !== id);
};

const addToState = (data, state, prop) => {
  state[prop] = { meta: state[prop]['meta'], data: state[prop]['data'].concat(data) };
};

const actions = {
  // ---------------- queries ------------------
  async getReferrers({ commit }, params) {
    try {
      const res = await axiosClient.get('admin/referrers', {
        params: { ...params, per_page: 15 },
      });
      commit('setReferrers', res.data);
      return res.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getReferralsAll({ commit }, { id, params }) {
    try {
      const { data } = await axiosClient.get(`admin/referrers/${id}/referrals`, { params });
      commit('setReferralsAll', { data: data.data, id });
      return data.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getReferrersPending({ commit }, params) {
    try {
      const res = await axiosClient.get('admin/referrers/pending', {
        params: { ...params, per_page: 15 },
      });
      commit('setReferrersPending', res.data);
      return res.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getGeneralReferrersPending({ commit }, params) {
    try {
      const res = await axiosClient.get('admin/referrers/general_pending', {
        params: { ...params, per_page: 15 },
      });
      commit('setReferrersPending', res.data);
      return res.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getReferralsPending({ commit }, { id, params }) {
    try {
      const { data } = await axiosClient.get(`admin/referrers/${id}/referrals/pending`, { params });
      commit('setReferralsPending', { data: data.data, id });
      return data.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getCustomers({ commit }, params) {
    try {
      const res = await axiosClient.get('admin/customers', {
        params: { per_page: 15, ...params },
      });
      commit('setCustomers', res.data);
      return res.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getNotifications({ commit }, params) {
    try {
      const res = await axiosClient.get('admin/notifications', {
        params: { per_page: 15, ...params },
      });
      commit('setNotifications', res.data);
      return res.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getContacts({ commit }, params) {
    try {
      const res = await axiosClient.get('admin/customer_users', {
        params: { per_page: 15, ...params },
      });
      commit('setContacts', res.data);
      return res.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getProducts({ commit }, params) {
    try {
      const res = await axiosClient.get('admin/products', {
        params: {
          per_page: 15,
          lang_code: 'en',
          includes: ['accessories', 'resources'],
          ...params,
        },
      });
      commit('setProducts', res.data);
      return res.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getAccessories({ commit }, params) {
    try {
      const res = await axiosClient.get('admin/accessories', {
        params: { per_page: 15, lang_code: 'en', ...params },
      });
      commit('setAccessories', res.data);
      return res.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getSeries({ commit }) {
    try {
      const { data } = await axiosClient.get('admin/groups', {
        params: { per_page: 100 },
      });
      commit('setSeries', data.data);
      return data.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getSalesReps({ commit }, params) {
    try {
      const { data } = await axiosClient.get('/admin/sales-rep', {
        params: { per_page: 15, ...params },
      });
      commit('setSaleRep', data);
      return data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getPayoutTags({ commit }, params) {
    try {
      const { data } = await axiosClient.get('/admin/referral-payout-tag', {
        params: { per_page: 15, ...params },
      });
      commit('setPayoutTags', data);
      return data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getMachineTypes({ commit }, params) {
    try {
      const { data } = await axiosClient.get('/admin/machine-type', {
        params: { per_page: 1000, ...params },
      });
      commit('setMachineTypes', data);
      return data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getGroupCategories({ commit }, params) {
    try {
      const { data } = await axiosClient.get('/admin/group-categories', {
        params: { per_page: 100, ...params },
      });
      commit('setGroupCategories', data);
      return data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async getTemplates({ commit }, params) {
    try {
      const { data } = await axiosClient.get('/admin/template', {
        params: { per_page: 1000, ...params },
      });
      commit('setTemplates', data);
      return data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  // ---------------- mutations ------------------
  async addSaleRep({ commit }, { data }) {
    try {
      const res = await axiosClient.post('/admin/sales-rep', data);
      commit('addSaleRep', res.data.data);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async updateSaleRep({ commit }, { id, data }) {
    try {
      const res = await axiosClient.post(`admin/sales-rep/${id}`, data);
      commit('updateSaleRep', res.data.data);
    } catch (error) {
      console.error({ ...error });
    }
  },
  async deleteSaleRep({ commit }, id) {
    try {
      const res = await axiosClient.delete(`/admin/sales-rep/${id}`);
      commit('removeSaleRep', id);
      return res;
    } catch (error) {
      console.error({ ...error });
      throw error;
    }
  },
  async redeemReferral({ commit }, { customer_id, amount }) {
    try {
      const { data } = await axiosClient.post(`admin/referrals/redeem`, { customer_id, amount });
      commit('updateReferralPending', data.success);
    } catch (error) {
      console.error({ ...error });
    }
  },

  async addCustomer({ commit }, { data }) {
    try {
      const res = await axiosClient.post('admin/customers', data);
      commit('addCustomer', res.data.data);
      return res.data.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async updateCustomer({ commit }, { customerId, data }) {
    try {
      const res = await axiosClient.put(`admin/customers/${customerId}`, data);
      commit('updateCustomer', res.data.data);
      return res.data.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async addContact({ commit }, { data }) {
    try {
      const res = await axiosClient.post('admin/customer_users', data);
      commit('addContact', res.data.data);
      return res.data.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async updateContact({ commit }, { contactId, data }) {
    try {
      const res = await axiosClient.put(`admin/customer_users/${contactId}`, data);
      commit('updateContact', res.data.data);
      return res.data.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async deleteContact({ commit }, id) {
    try {
      const res = await axiosClient.delete(`admin/customer_users/${id}`);
      commit('removeContact', id);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async addNotification({ commit }, { data }) {
    try {
      const res = await axiosClient.post('admin/notifications', data);
      commit('addNotification', res.data.data);
      return res.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async updateNotification({ commit }, { notificationId, data }) {
    try {
      const res = await axiosClient.put(`admin/notifications/${notificationId}`, data);
      commit('updateNotification', res.data.data);
      return res.data.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async publishNotification({ commit }, id) {
    try {
      const res = await axiosClient.patch(`admin/notifications/${id}/publish`);
      commit('updateNotification', res.data);
      return res.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async deleteNotification({ commit }, id) {
    try {
      const res = await axiosClient.delete(`admin/notifications/${id}`);
      commit('removeNotification', id);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async addProduct({ commit }, { data }) {
    try {
      const res = await axiosClient.post('/admin/products', data);
      commit('addProduct', res.data.data);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async updateProduct({ commit }, { id, data }) {
    try {
      const res = await axiosClient.post(`admin/products/${id}/save`, data);
      commit('updateProduct', res.data.data);
    } catch (error) {
      console.error({ ...error });
    }
  },

  async deleteProduct({ commit }, id) {
    try {
      const res = await axiosClient.delete(`/admin/products/${id}`);
      commit('removeProduct', id);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async addAccessory({ commit }, { data }) {
    try {
      const res = await axiosClient.post('/admin/accessories', data);
      commit('addAccessory', res.data.data);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async deleteAccessory({ commit }, id) {
    try {
      const res = await axiosClient.delete(`/admin/accessories/${id}`);
      commit('removeAccessory', id);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async updateAccessory({ commit }, { id, data }) {
    try {
      const res = await axiosClient.post(`/admin/accessories/${id}`, data);
      commit('updateAccessory', res.data.data);
      return res.data.data;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async addSerie({ commit }, data) {
    try {
      const res = await axiosClient.post('/admin/groups', {
        name: data.name,
        required: data.required,
        has_training: data.has_training,
        requires_rep_approval: data.requires_rep_approval,
        category_id: data.category_id,
      });
      commit('addSerie', res.data.data);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async updateSerie(
    { commit },
    { id, name, required, has_training, category_id, category_name, requires_rep_approval },
  ) {
    try {
      const res = await axiosClient.put(`/admin/groups/${id}`, {
        name: name,
        required: required,
        has_training: has_training,
        category_id: category_id,
        category_name: category_name,
        requires_rep_approval: requires_rep_approval,
      });
      commit('updateSerie', res.data.data);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async deleteSerie({ commit }, id) {
    try {
      const res = await axiosClient.delete(`/admin/groups/${id}`);
      commit('removeSerie', id);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async addPayoutTag({ commit }, { tagId, data }) {
    try {
      const res = await axiosClient.post(`/admin/machine-type-referral-payout-tag/${tagId}`, {
        machine_type_referral_tag: data,
      });
      commit('addPayoutTag', res.data.data);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async updatePayoutTag({ commit }, { tagId, data }) {
    try {
      const res = await axiosClient.post(`/admin/machine-type-referral-payout-tag/${tagId}`, {
        machine_type_referral_tag: data,
      });
      commit('updatePayoutTag', res.data.data);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async deletePayoutTag({ commit }, id) {
    try {
      const res = await axiosClient.delete(`/admin/referral-payout-tag/${id}`);
      commit('removePayoutTag', id);
      return res;
    } catch (error) {
      console.error({ ...error });
      throw error;
    }
  },
};

const mutations = {
  setReferrers(state, { data, meta }) {
    state.referrers = { data, meta };
  },
  setReferralsAll(state, { data, id }) {
    state.referralsAll = { ...state.referralsAll, [id]: data };
  },
  setReferrersPending(state, { data, meta }) {
    state.referrersPending = { data, meta };
  },
  setReferralsPending(state, { data, id }) {
    state.referralsPending = { ...state.referralsPending, [id]: data };
  },
  setPayoutTags(state, { data, meta }) {
    state.payoutTags = { data, meta };
  },
  setSaleRep(state, { data, meta }) {
    state.salesReps = { data, meta };
  },
  setCustomers(state, { data, meta }) {
    state.customers = { data, meta };
  },
  setContacts(state, { data, meta }) {
    state.contacts = { data, meta };
  },
  setProducts(state, { data, meta }) {
    state.products = { data, meta };
  },
  setAccessories(state, { data, meta }) {
    state.accessories = { data, meta };
  },
  setMachineTypes(state, { data, meta }) {
    state.machineTypes = { data, meta };
  },
  setGroupCategories(state, { data, meta }) {
    state.groupCategories = { data, meta };
  },
  setTemplates(state, { data, meta }) {
    state.templates = { data, meta };
  },
  setNotifications(state, { data, meta }) {
    state.notifications = { data, meta };
  },
  setSeries(state, series) {
    state.series = series;
  },
  addSerie(state, serie) {
    state.series = state.series.concat(serie);
  },
  addCustomer(state, customer) {
    addToState(customer, state, 'customers');
  },
  addContact(state, contact) {
    addToState(contact, state, 'contacts');
  },
  addNotification(state, notification) {
    addToState(notification, state, 'notifications');
  },
  addSaleRep(state, salesRep) {
    addToState(salesRep, state, 'salesReps');
  },
  addProduct(state, product) {
    addToState(product, state, 'products');
  },
  addAccessory(state, accessory) {
    addToState(accessory, state, 'accessories');
  },
  addPayoutTag(state, tag) {
    addToState(tag, state, 'payoutTags');
  },
  updateCustomer(state, customer) {
    updateState(customer, state, 'customers');
  },
  updateContact(state, contact) {
    updateState(contact, state, 'contacts');
  },
  updateNotification(state, notification) {
    updateState(notification, state, 'notifications');
  },
  updateAccessory(state, accessory) {
    updateState(accessory, state, 'accessories');
  },
  updateSaleRep(state, salesRep) {
    updateState(salesRep, state, 'salesReps');
  },
  updateProduct(state, product) {
    updateState(product, state, 'products');
  },
  updateSerie(
    state,
    { id, name, required, has_training, requires_rep_approval, category_id, category_name },
  ) {
    state.series = state.series.map(serie =>
      serie.id === id
        ? {
            ...serie,
            requires_rep_approval,
            name,
            required,
            has_training,
            category_id,
            category_name,
          }
        : serie,
    );
  },
  updatePayoutTag(state, payoutTag) {
    updateState(payoutTag, state, 'payoutTags');
  },
  updateReferralPending(state, data) {
    const { customer_id, balance } = data;
    // update referrers balance or remove from array of balance is greater than 0
    state.referrersPending.data = state.referrersPending.data
      .map(referrers => (referrers.id === customer_id ? { ...referrers, balance } : referrers))
      .filter(({ balance }) => balance > 0);

    // update the referrals array
    state.referralsPending[customer_id]
      ? (state.referralsPending[customer_id] = [
          { ...data, referral_value: parseFloat(data.referral_value) },
          ...state.referralsPending[customer_id],
        ])
      : (state.referralsPending[customer_id] = [data]);

    // update referral history as well
    state.referralsAll[customer_id] &&
      (state.referralsAll[customer_id] = [
        { ...data, referral_value: parseFloat(data.referral_value) },
        ...state.referralsAll[customer_id],
      ]);
  },
  removeContact(state, id) {
    removeFromState(id, state, 'contacts');
  },
  removeNotification(state, id) {
    removeFromState(id, state, 'notifications');
  },
  removeReferralsPending(state, ids) {
    state.referralsPending.data = state.referralsPending.data.filter(
      referral => !ids.some(id => id === referral.id),
    );
  },
  removeSerie(state, id) {
    state.series = state.series.filter(serie => serie.id !== id);
  },
  removeAccessory(state, id) {
    removeFromState(id, state, 'accessories');
  },
  removeProduct(state, id) {
    removeFromState(id, state, 'products');
  },
  removePayoutTag(state, id) {
    removeFromState(id, state, 'payoutTags');
  },
  removeSaleRep(state, id) {
    removeFromState(id, state, 'salesReps');
  },
};

export const admin = {
  actions,
  getters,
  state,
  mutations,
  namespaced: true,
};
